/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { I18nContext } from "../../context/I18nProvider";
import ObserverContext from "../../context/Observer";

import useScrollToTop from "../../hooks/useScrollToTop";
import usePrevious from "../../hooks/usePrevious";

import api from "../../api/Api";
import RelatedPackages from "./RelatedPackages";
import SportsPackagesDetailsLoader from "../Loaders/SportsPackagesDetailsLoader";
import {
  MoonIcon,
  CalendarDetailIcon,
  LocationDetailIcon,
} from "../../components/icons";

import imgPlaceholder from "../../assets/images/static/sport__hero_desktop.jpg";

const SportsPackagesDetails = () => {
  const [prevId, setPrevId] = useState(null);
  const [allPackages, setAllPackages] = useState([]);
  const [packages, setPackages] = useState({
    loading: false,
    data: {
      id: null,
      category: "",
      date: [],
      title: "",
      description: "",
      location: "",
      image: "",
      details: {
        subtitle: "",
        nigths: null,
        price: 0,
        descripcion: [],
        termsConditions: "",
      },
    },
    error: null,
  });

  const { t } = useTranslation();
  const { id } = useParams();
  const previousId = usePrevious(prevId);

  const { setActualComponent } = useContext(I18nContext);
  const { setElementInview } = useContext(ObserverContext);

  // Scroll to top
  useScrollToTop();

  // Detectamos el scroll del contenedor line
  const handleScroll = (e) => {
    e.preventDefault();

    const top = window.scrollY < 343;

    setElementInview(!top);
  };

  const getData = async () => {
    setPackages({
      ...packages,
      loading: true,
      error: null,
    });

    try {
      const {data} = await api.packages.getAll();
      const filter = data.find((item) => item.id === Number(id));

      setAllPackages(data);
      setPackages({
        data: filter,
        loading: false,
      });
    } catch (error) {
      setPackages({
        loading: false,
        error,
      });
      console.log("error");
    }
  };

  // Seteamos el componente actual, para las traduccion de rutas
  useEffect(() => {
    setActualComponent("psportsdetails");
  }, [setActualComponent]);

  useEffect(() => {
    id !== previousId && setPrevId(id);
    getData();
  }, [id]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    getData();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (packages.loading === true) {
    return <SportsPackagesDetailsLoader />;
  }

  return (
    <section className="sportDetails">
      <div
        style={{
          backgroundImage: `url(${
            packages.data?.image ? packages.data?.image : imgPlaceholder
          })`,
        }}
        className="sportDetails__image triangle right"
      ></div>

      <div className="sportDetails__content">
        <div className="sportDetails__content__header">
          <h1>
            {
              packages.data?.title.split(" ").map(word => {
                if(word.length > 12) {
                  return (
                  <span className="sportDetails__content__large-word">
                    { word.slice(0, 4) }
                    <span className="sportDetails__content__white-space"> </span>
                    { word.slice(4) }
                  </span>)
                }
                return word + " "
              })
            }
          </h1>
          <p>{packages.data?.details?.subtitle}</p>
        </div>
        <div className="sportDetails__content__cards">
          <div className="sportDetails__content__cards-time">
            <p>
              <CalendarDetailIcon /> {packages.data?.date?.join(" - ")}
            </p>

            <p>
              <MoonIcon /> {packages.data?.details?.nigths} noches
            </p>

            <p>
              <LocationDetailIcon />{" "}
              {packages.data?.location?.replace("-", " ")}
            </p>
          </div>

          <div className="sportDetails__content__cards-price">
            <p>Desde</p>
            <h3>
              <span>U$D</span> {packages.data?.details?.price.toLocaleString()}
            </h3>
          </div>
        </div>{" "}
      </div>

      <div className="sportDetails__description">
        <h3>Descripción</h3>

        <ul>

            <li>{packages.data?.description}</li>


          {packages.data?.details.includes && (
            <>
              <h4>Incluye: </h4>
              <ul>
                {packages.data?.details.includes?.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </>
          )}

          {packages.data?.additionals?.length > 0 && (
            <>
              <h4>Adicionales</h4>
              <ul className="sportDetails__description__additionals">
                {packages.data.additionals.map((item, index) => (
                  <li key={index}>
                    <div className="sportDetails__description__additionals-title">
                      {item.title && <strong>{item.title}</strong>}
                      {item.text &&
                        item.text.trim().toLowerCase() !== "desde" && (
                          <p>{item.text}</p>
                        )}
                    </div>
                    {item.price != null && item.price !== "" && (
                      <div className="sportDetails__description__additionals-meta">
                        <span className="sportDetails__description__additionals-from">
                          desde
                        </span>
                        <span className="sportDetails__description__additionals-price">
                          U$D {Number(item.price).toLocaleString()}
                        </span>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </>
          )}

          <li className="sportDetails__description__link">
            <Link to={t("routes.contact")}>Reservar</Link>
          </li>
        </ul>
      </div>

      <div className="sportDetails__legals">
        <div className="sportDetails__legals__container">
          <small>
            <b>Políticas y Condiciones</b> <br />
          </small>
          <small>{packages.data?.details?.termsConditions}</small>
        </div>
      </div>

      {allPackages?.length ? (
        <RelatedPackages allPackages={allPackages} packages={packages.data} />
      ) : null}
    </section>
  );
};

export default SportsPackagesDetails;
